var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13867 0H18.832C19.6645 0 20.4628 0.330681 21.0514 0.919296C21.64 1.50791 21.9707 2.30624 21.9707 3.13867C21.9707 3.9711 21.64 4.76943 21.0514 5.35805C20.4628 5.94666 19.6645 6.27734 18.832 6.27734H3.13867C2.30624 6.27734 1.50791 5.94666 0.919296 5.35805C0.330681 4.76943 0 3.9711 0 3.13867C0 2.30624 0.330681 1.50791 0.919296 0.919296C1.50791 0.330681 2.30624 0 3.13867 0ZM25.1094 25.1094H40.8027C41.6352 25.1094 42.4335 25.4401 43.0221 26.0287C43.6107 26.6173 43.9414 27.4156 43.9414 28.248C43.9414 29.0805 43.6107 29.8788 43.0221 30.4674C42.4335 31.056 41.6352 31.3867 40.8027 31.3867H25.1094C24.2769 31.3867 23.4786 31.056 22.89 30.4674C22.3014 29.8788 21.9707 29.0805 21.9707 28.248C21.9707 27.4156 22.3014 26.6173 22.89 26.0287C23.4786 25.4401 24.2769 25.1094 25.1094 25.1094ZM3.13867 12.5547H40.8027C41.6352 12.5547 42.4335 12.8854 43.0221 13.474C43.6107 14.0626 43.9414 14.8609 43.9414 15.6934C43.9414 16.5258 43.6107 17.3241 43.0221 17.9127C42.4335 18.5014 41.6352 18.832 40.8027 18.832H3.13867C2.30624 18.832 1.50791 18.5014 0.919296 17.9127C0.330681 17.3241 0 16.5258 0 15.6934C0 14.8609 0.330681 14.0626 0.919296 13.474C1.50791 12.8854 2.30624 12.5547 3.13867 12.5547Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbar);
export default __webpack_public_path__ + "static/media/navbar.04cd55c67ee99fdf8631d4e1f82c2652.svg";
export { ForwardRef as ReactComponent };